import { Component, Input, Output, EventEmitter, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';

import { Util } from '../utils/utils.module';
import { ListItem } from '../models/list-item';
import { LocalizeService } from '../services/localize.service';
import { SchemaService } from '../services/schema.service';
import { ColFormat, ColumnDesc } from '../models/column';
import { DataService } from '../services/data.service';
import { LookupService } from '../services/lookup.service';
import { ListService } from '../services/list.service';
import { ListTableComponent } from './list-table.component';
import { ShortcutsService } from '../services/shortcuts.service';

@Component ({
  selector: 'edx-list-summary',
  styleUrls: [ 'list-table.component.scss', 'list-summary.component.scss' ],
  providers: [ListService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: ListTableComponent.baseClassInputs,
  template: `
    <div class="summary" [ngClass]="{slidright: hitPreviewShown, slidingleft: hitPreviewHiding, slidingright: hitPreviewShowing}">
      <div class="header" id="edx_summary_list_header">
        <div class="selector" tabindex="0" (click)="headerSelectClick()" role="checkbox" [attr.aria-label]="isChrome?(allSelected?altLabels['selectAll']:altLabels['selectAll']+' '):altLabels['selectAll']" [attr.aria-checked]="allSelected?allSelected:!noneSelected?'mixed':allSelected" (keydown.space)="headerSelectClick()" [ngClass]="{headerselect:!!getList().length, partialselect:!noneSelected, allselect:allSelected}"></div>
        <div *ngIf="sortColumnName()" class="inline sorter" id="edx_hdr_sort_column">
          <div class="inline icon arrow" [ngClass]="{reverse:sortIsReverse()}" tabindex="0" (click)="sortClicked($event)" (keydown.space)="sortClicked($event)" role="button" [attr.aria-label]="sortIsReverse()?this.localizer.getTranslation('TOOLTIP.SORT_ARROW_DESCENDING',[sortColumnName()]):this.localizer.getTranslation('TOOLTIP.SORT_ARROW_ASCENDING',[sortColumnName()])"></div>
          <div class="name sortname">{{sortColumnName()}}</div>
          <edx-menu [menuID]="31" [callback]="parent" [forceMenuButton]="true" class="inline sortcol" [tabIndex]="0" [ariaLabel]="altLabels['sortMenu']"></edx-menu>
        </div>
        <div class="headerexpand" [ngClass]="{allexpand: allExpanded}" tabindex="0" role="button" [attr.aria-label]="allExpanded?altLabels['detailsExpanded']:altLabels['detailsCollapsed']" (click)="headerExpandClick($event)" (keyp.enter)="headerExpandClick($event)" (keydown.space)="headerExpandClick($event)"></div>
      </div>
      <div #container class="container" [ngClass]="{dragover:dragover}" [edx-drag-target]="this">
        <div #listContainer class="listcontainer" id="edx_summary_list_container">
          <div *ngIf="!reloading && (!getList() || !getList().length)"><div class="item nohits">{{noHits}}</div></div>
          <ng-template ngFor let-listitem [ngForOf]="getList()" let-i="index">
            <div [id]="i" class="item" tabindex="0" [ngClass]="{selected:selections.indexOf(listitem)>=0, disabled:!isSelectable(listitem), dropfolder:dropFolder(listitem), dragover:dragOverItem===listitem, folder:isContainer(listitem)}" (mouseover)="enableHoverMenu(i)" (mouseleave)="disableHoverMenu(i)" (focus)="enableHoverMenu(i)" (keyup.arrowleft)="hitPreviewShown?focusOnPreviewPane(i):null">
              <div class="selector" [ngClass]="{disabled:!canSelectItem(listitem)}" [tabindex]="!canSelectItem(listitem)?-1:0" role="checkbox" [attr.aria-label]="isChrome?(selections.indexOf(listitem)>=0?altLabels['rowSelector']:altLabels['rowSelector']+' '):altLabels['rowSelector']" [attr.aria-checked]="selections.indexOf(listitem)>=0" (click)="selectorClick(listitem, $event)" (keydown.space)="selectorClick(listitem, $event)" [id]="getRowSelectorId(i)"></div>
              <div class="appicon" role="img" tabindex="0" [attr.aria-label]="formatTypeText(listitem)" (click)="listItemClicked(listitem, $event)" (keydown.space)="listItemClicked(listitem, $event)">
                <edx-spinner *ngIf="listitem.id==='' && listitem.lib==='' " [mini]="true"></edx-spinner>
                <img *ngIf="listitem.id!=='' || listitem.lib!==''" class="rowicon clickable" src="{{formatTypeIcon(listitem)}}" alt="{{formatTypeText(listitem)}}" (click)="listItemClick(listitem, $event, 'APP_ID')">
                <img *ngIf="displayMiniStatus(listitem, 'APP_ID')" class="overlaystatusicon clickable" src="{{formatStatusIcon(listitem)}}" alt="{{formatStatusText(listitem)}}" (click)="listItemClick(listitem, $event, 'APP_ID')">
                <img *ngIf="displayTopMiniStatus(listitem, 'APP_ID')" class="overlaystatusicon top clickable" src="{{formatTopStatusIcon(listitem)}}" alt="{{formatStatusText(listitem)}}" (click)="listItemClick(listitem, $event, 'APP_ID')">
              </div>
              <div class="maincontent">
                  <edx-inline-action-bar *ngIf="inlineActionMenuId!==-1" [resid]="inlineActionMenuId" [shown]="listitem===hoverListItem" [listItem]="listitem" [target]="inlineActionTarget"></edx-inline-action-bar>
                <div class="name" tabindex="0" role="link" (click)="listItemClicked(listitem, $event)" [attr.aria-label]="'DOCNAME'+' '+formatString(listitem,'DOCNAME')" (keydown.space)="listItemClicked(listitem, $event)" (keyup.enter)="listItemClicked(listitem, $event)">{{formatString(listitem,'DOCNAME')}}</div>
                <div class="hitpreview" tabindex="0">
                  <edx-list-item-preview [desc]="listitem"></edx-list-item-preview>
                </div>
              </div>
              <div class="extracontent">
                <span *ngIf="extraCols.length">
                  <ng-template ngFor let-col [ngForOf]="extraCols" let-iCol="index">
                    <div *ngIf="isColumnShown(listitem, iCol)" class="extrarow">
                      <div class="label">{{col.label}}</div>
                      <span [ngSwitch]="col.format">
                        <div *ngSwitchCase="2" class="name">{{formatString(listitem,col.property,col.displayMap)}}</div>
                        <div *ngSwitchCase="3" class="name">{{formatDate(listitem, col.property)}}</div>
                        <div *ngSwitchCase="5" class="status">
                          <img *ngIf="displayStatusIcon(listitem)" class="statusicon" src="{{formatStatusIcon(listitem)}}" alt="{{formatStatusText(listitem)}}">
                          <div class="name" [ngClass]="{italic:statusTextItalic(listitem), red:statusTextRed(listitem), blue:statusTextBlue(listitem)}">{{formatStatusText(listitem)}}</div>
                        </div>
                        <div *ngSwitchCase="7" class="name">{{formatPath(listitem[col.property])}}</div>
                        <div *ngSwitchCase="9" class="name">{{formatAction(listitem)}}</div>
                        <div *ngSwitchCase="11" class="name relevance"><edx-progress [value]="formatProgress(listitem)"></edx-progress></div>
                        <div *ngSwitchCase="12" class="name">{{formatEnum(listitem,col.property,iCol)}}</div>
                        <div *ngSwitchCase="15" class="name">{{formatDate(listitem, col.property)}}</div>
                        <div *ngSwitchDefault class="name">{{formatString(listitem,col.property,col.displayMap)}}</div>
                      </span>
                    </div>
                  </ng-template>
                </span>
              </div>
              <div [tabindex]="0" [title]="getFavoriteImageToolTip(listitem)"
                [ngClass]="{rowicon: true, oai: officeAddin, clickable: isClickable(listitem,'is_favorite'), favoriteIcon: IsFavoriteItem(listitem), notFavoriteIcon: !IsFavoriteItem(listitem)}"
                (click)="listItemClick(listitem, $event, 'is_favorite')"
                role="button"
                (keyup.enter)="listItemClick(listitem, $event, 'is_favorite')"
                (keydown.space)="listItemClick(listitem, $event, 'is_favorite')">
              </div>
              <div class="expander" [ngClass]="{expanded:isExpanded(listitem)}" tabindex="0" role="button" [attr.aria-label]="getAriaLabelForSummaryExpander(listitem)" [attr.aria-expanded]="isExpanded(listitem)" (click)="expanderClick(listitem, $event)" (keydown.space)="expanderClick(listitem, $event)" (keyup.enter)="expanderClick(listitem, $event)"></div>
            </div>
          </ng-template>
        </div>
      </div>
      <edx-spinner *ngIf="reloading"></edx-spinner>
    </div>
    <div *ngIf="hitPreviewShown" class="hitpreviewpopup" [ngClass]="{shown: hitPreviewShown, hiding: hitPreviewHiding, showing: hitPreviewShowing}" (mouseleave)="hitPreviewLeave($event)" (animationend)="hitPreviewAnimationComplete()" (keyup.arrowright)="focusOnRowSelector()">
      <div class="hitpreviewheader">
        <div class="hitpreviewtitle">{{hitPreviewData?hitPreviewData.DOCNAME:""}}</div>
        <div class="hitpreviewpager">
          <span>{{getPageOfPages()}}</span>
          <div class="hitpreviewbuttons">
            <div class="rowicon prev" tabindex="0" role="button" [attr.aria-label]="altLabels['previousPage']" id="edx_hit_preview_prev" (click)="showHitPreview(null, -1)" (keydown.space)="showHitPreview(null, -1)"></div>
            <div class="rowicon next" tabindex="0" role="button" [attr.aria-label]="altLabels['nextPage']" id="edx_hit_preview_next" (click)="showHitPreview(null, 1)" (keydown.space)="showHitPreview(null, 1)"></div>
          </div>
        </div>
      </div>
      <div class="hitpreviewcontainer" tabindex="0">
        <div class="hitpreviewbody">
          <edx-spinner *ngIf="hitPreviewLoading"></edx-spinner>
        <edx-list-item-preview *ngIf="hitPreviewData" [data]="hitPreviewData.runs"></edx-list-item-preview>
        </div>
      </div>
    </div>
  `
})
export class ListSummaryComponent extends ListTableComponent {
  @ViewChild('container') private container: ElementRef;
  @ViewChild('listContainer') private listContainer: ElementRef;
  @Input() schemaLayout = false;
  @Output() actionHandler: EventEmitter<string> = new EventEmitter<string>();
  public seeAllStr: string = this.localizer.getTranslation('TOOLTIP.SEE_ALL');
  public seeMoreStr: string = this.localizer.getTranslation('TOOLTIP.SEE_MORE');
  private extraColsShown = 3;
  private extraCols: ColumnDesc[] = [];

  constructor(protected listService: ListService, protected changeDetector: ChangeDetectorRef, protected schemaService: SchemaService,
              protected localizer: LocalizeService, protected dataService: DataService, protected lookupService: LookupService, shortcutsService: ShortcutsService) {
    super(listService, changeDetector, schemaService, localizer, dataService, lookupService, shortcutsService);
  }

  public getPageOfPages(): string {
    return this.hitPreviewData?this.localizer.getTranslation('PAGINATOR.OF_PAGES',[this.hitPreviewData.page,this.hitPreviewData.totalpages]):'';
  }

  private isContainer(item: ListItem): boolean {
    return Util.isContainer(item.type);
  }

  private isColumnShown(item: ListItem, iCol: number): boolean {
    return iCol<3 || this.expandedItems.indexOf(item)>=0;
  }

  private getAriaLabelForSummaryExpander(listitem: ListItem): string {
    return Util.Device.bIsChrome && this.isExpanded(listitem) ? this.altLabels['seeMore'] : this.altLabels['seeMore'] + ' ';
  }

  private sortClicked(event: Event): void {
    this.headerColumnClick(event, this.getSortCol());
    this.changeDetector.markForCheck();
  }

  private sortIsReverse(): boolean {
    return !!this.ascending;
  }

  public sortColumnName(): string {
    if (this.schema) {
      const sortCol: string = this.getSortCol();
      if (sortCol) {
        let column: ColumnDesc = this.schema.columns.find(c => c.property===sortCol);
        if (!column) {
          column = this.schema.columns.find(c => c.property===this.schema.sortAscending || c.property===this.schema.sortDescending);
        }
        if (column) {
          return column.label;
        }
      }
    }
    return null;
  }

  protected descChanged(newDesc: any): void {
    super.descChanged(newDesc);
    this.layoutComplete = false;
    this.setVisibleColumnCount();
  }

  protected setVisibleColumnCount(): void {
    if (!this.layoutComplete) {
      const isSearch: boolean = this.desc && this.desc.id.startsWith('evaluation');
      const isSearchSaved: boolean = this.desc && this.desc.type === 'searches' && !isNaN(parseInt(this.desc.id));
      this.extraCols = [];
      if (this.schema && this.schema.columns) {
        let col = this.schema.columns.find(c => c.property === 'relevance');
        if (!!col) {
          this.extraCols.push(col);
        }
        for (col of this.schema.columns) {
          if (!!col.label && col.property !== 'relevance' && col.property !== 'APP_ID' && col.property !== 'DOCNAME' && col.format !== ColFormat.EXPANDER && col.format !== ColFormat.SELECTOR) {
            this.extraCols.push(col);
          }
        }
      }
      this.changeDetector.markForCheck();
      this.layoutComplete = true;
    }
  }

  protected getContainerElement(): HTMLElement {
    return this.container ? this.container.nativeElement : null;
  }

  protected getListElement(): HTMLElement {
    return this.listContainer ? this.listContainer.nativeElement : null;
  }

  protected getDragOverInfo(event: any): {dragChanged: boolean; rowDocName: string} {
    let target: any = event.target;
    let dragChanged = false;
    let rowDocName: string;

    while (target && !target.classList.contains('item')) {
      target = target.parentElement;
    }
    if (target) {
      if (this.dragoverTR !== target) {
        this.dragLeave(null, null);
        this.dragoverTR = target;
        if (!target.classList.contains('dropfolder')) {
          dragChanged = true;
          this.dragover = this.dragoverHasFiles;
        } else {
          const index: number = Array.prototype.indexOf.call(this.dragoverTR.parentNode.children, this.dragoverTR);
          if (index>=0 && index<this.list.length) {
            this.dragOverItem = this.list[index];
            rowDocName = this.dragOverItem.DOCNAME;
          }
          this.dragover = false;
          dragChanged = true;
          this.dragoverTR.classList.add('dragover');
        }
      }
    } else {
      dragChanged = true;
    }
    return {dragChanged, rowDocName};
  }

  public commandEnabled(cmd: string): boolean {
    if (cmd.startsWith('list_choosecol_')) {
      if (!this.set || !this.set.limitedsorting || this.set.limitedsorting.indexOf(cmd.substr(15))!==-1) {
        return true;
      } else {
        return false;
      }
    }
    return super.commandEnabled(cmd);
  }

  public doCommand(cmd: string): boolean {
    if (cmd.startsWith('list_choosecol_')) {
      if (this.descending) {
        this.descending = cmd.substr(15);
      } else if (this.ascending) {
        this.ascending = cmd.substr(15);
      }
      this.resort(1);
      return true;
    }
    return super.doCommand(cmd);
  }

  public focusOnFirstRow(): void {
    ((this.container?.nativeElement as HTMLElement)?.getElementsByClassName('item')[0] as HTMLElement)?.focus();
  }
}
